import graphql from "babel-plugin-relay/macro";

const AllPoliticianByPartyIdQuery = graphql`
query AllPoliticianByPartyIdQuery($party:ID,$first:Int){
  allPoliticians(party:$party,first:$first){
    edges{
            node{
              id
              name
              politicianImage
              party{
                partyName
              }
              price 
           
              
            }
          }
  }
}
`

export default AllPoliticianByPartyIdQuery;
// stockOwnedCount
// priceDiff
// priceDiffPercentage
// priceDiff
// stockLowValue
//         stockHighValue
//         stockHighValueLongTerm
//         stockLowValueLongTerm